import React, { useContext, useState } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import StarekContext from "../context/StarekContext";

function Menu() {
  const starekContext = useContext(StarekContext);
  const location = useLocation();
  const navigator = useNavigate();

  const [openMenus, setOpenMenus] = useState({
    setup: false,
    plan: false,
    track: false,
    manage: false,
    more: false,
  });

  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleNavigation = (e, path) => {
    e.preventDefault();
    document.body.classList.add("page-slide-right");
    setTimeout(() => {
      navigator(path);
      document.body.classList.remove("page-slide-right");
    }, 500);
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <div>
        <a href="/" className="text-decoration-none">
          <img
            src="/dist/img/light-starek-brand-512x512.png"
            alt="Starek"
            style={{
              opacity: "0.8",
              marginTop: 20,
              scale: "0.80",
            }}
          />
        </a>
      </div>
      {starekContext?.lastUsedWorkspace?.logo ? (
        <div
          style={{
            minHeight: "84px",
          }}
        >
          <a href="/" className="text-decoration-none">
            <img
              src={starekContext?.lastUsedWorkspace?.logo}
              alt="Starek"
              style={{
                opacity: "0.8",
                marginTop: 10,
              }}
            />
          </a>
        </div>
      ) : (
        <div className="text-center bg-gray font-weight-700">
          <i>{starekContext?.lastUsedWorkspace?.name}</i>
        </div>
      )}

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
            <li
              className="nav-item"
              onClick={(e) => {
                sessionStorage.setItem(
                  "postAuthRedirect",
                  location.pathname + location.search
                );
                handleNavigation(e, "/choose-plant");
              }}
            >
              <a href="/choose-plant" className="nav-link">
                <i className="fa fa-industry text-light ms-1 me-2"></i>
                <p className="text-light">
                  {starekContext?.lastUsedPlant?.name}
                </p>
              </a>
            </li>

            <hr className="text-white mt-2 mx-n2" />

            <li className="nav-item">
              <NavLink className="nav-link" to="/">
                <i className="nav-icon fas fa-th tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">DASHBOARD</b>
                </p>
              </NavLink>
            </li>

            {/* Setup Section */}
            <li className={`nav-item ${openMenus.setup ? "menu-open" : ""}`}>
              <div onClick={() => toggleMenu("setup")} className={`nav-link`}>
                <i className="nav-icon fa fa-clone tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">SETUP</b>
                  <i className="right fas fa-angle-left tw-text-[#c2c7d0]" />
                </p>
              </div>
              <ul
                className="nav nav-treeview"
                style={{
                  display: openMenus.setup ? "block" : "none",
                }}
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="/parts">
                    <i className="fa fa-hdd nav-icon" />
                    <p>Parts</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/cycles">
                    <i className="fa fa-recycle nav-icon" />
                    <p>Cycles</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/shifts">
                    <i className="fa fa-clipboard nav-icon" />
                    <p>Shifts</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/zones">
                    <i className="fa fa-bullseye nav-icon" />
                    <p>Zones</p>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Repeat this pattern for other sections */}

            {/* Plan */}
            <li className={`nav-item ${openMenus.plan ? "menu-open" : ""}`}>
              <div onClick={() => toggleMenu("plan")} className={`nav-link`}>
                <i className="nav-icon fa fa-drafting-compass tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">PLAN</b>
                  <i className="right fas fa-angle-left tw-text-[#c2c7d0]" />
                </p>
              </div>
              <ul
                className="nav nav-treeview"
                style={{
                  display: openMenus.plan ? "block" : "none",
                }}
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="/job-schedules">
                    <i className="far fa-calendar nav-icon" />
                    <p>Job Schedules</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/maintenance">
                    <i className="fa fa-funnel-dollar nav-icon" />
                    <p>Maintenance</p>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Track */}
            <li className={`nav-item ${openMenus.track ? "menu-open" : ""}`}>
              <div onClick={() => toggleMenu("track")} className={`nav-link`}>
                <i className="nav-icon fas fa-chart-line tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">TRACK</b>
                  <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                </p>
              </div>
              <ul
                className="nav nav-treeview"
                style={{
                  display: openMenus.track ? "block" : "none",
                }}
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="/reports">
                    <i className="fa fa-file-alt nav-icon" />
                    <p>Reports</p>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Manage */}
            <li className={`nav-item ${openMenus.manage ? "menu-open" : ""}`}>
              <div onClick={() => toggleMenu("manage")} className={`nav-link`}>
                <i className="nav-icon fa fa-cog tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">MANAGE</b>
                  <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                </p>
              </div>
              <ul
                className="nav nav-treeview"
                style={{
                  display: openMenus.manage ? "block" : "none",
                }}
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="/device-profiles">
                    <i className="fa fa-sd-card nav-icon" />
                    <p>Device Profiles</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/devices">
                    <i className="fa fa-microchip nav-icon" />
                    <p>Devices</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/settings">
                    <i className="fa fa-wrench nav-icon" />
                    <p>Settings</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/users">
                    <i className="fa fa-user nav-icon" />
                    <p>Users</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/roles">
                    <i className="fa fa-lock nav-icon" />
                    <p>Roles</p>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* More */}
            <li className={`nav-item ${openMenus.more ? "menu-open" : ""}`}>
              <div onClick={() => toggleMenu("more")} className={`nav-link`}>
                <i className="nav-icon fa fa-angle-double-right tw-text-[#c2c7d0]" />
                <p>
                  <b className="tw-text-[#c2c7d0]">MORE...</b>
                  <i className="fas fa-angle-left right tw-text-[#c2c7d0]" />
                </p>
              </div>
              <ul
                className="nav nav-treeview"
                style={{
                  display: openMenus.more ? "block" : "none",
                }}
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="/webhooks">
                    <i className="fa fa-bullhorn nav-icon" />
                    <p>Webhooks</p>
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Menu;
